<template>
  <v-app class="newback secondary">
    <!-- landing-start -->
    <v-img
      src="../../assets/movie/landing-03.jpg"
      min-height="100vh"
      min-width="100%"
    >
      <template #placeholder>
        <v-card
          color="#202a3d"
          flat
          class="fill-height"
          width="100%"
          height="100%"
        >
          <v-skeleton-loader
            min-height="100vh"
            width="100%"
            min-width="100%"
            v-bind="attrs"
            height="100h"
            type="image, image, image, image"
          />
        </v-card>
      </template>
      <v-overlay z-index="1" opacity="0.6" absolute></v-overlay>
      <v-row
        class="fill-height"
        align="center"
        justify="center"
        style="z-index: 2; position: relative"
      >
        <v-col cols="12" md="7">
          <v-main class="home_bg pt-0">
            <section id="Home" class="mb-16">
              <div
                class="home_logo d-flex align-center justify-center text-center d-block mx-auto"
              >
                <div class="logo_content d-block mx-auto">
                  <span class="logo">
                    <span>
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        xmlns:xlink="http://www.w3.org/1999/xlink"
                        height="80px"
                        width="87px"
                      >
                        <path
                          fill-rule="evenodd"
                          fill="rgb(255, 255, 255)"
                          d="M68.479,46.753 L55.101,55.064 L59.686,64.395 L26.302,64.395 L43.500,33.248 L48.558,41.524 L61.642,34.285 L43.500,-0.001 L0.000,80.001 L87.000,80.001 L68.479,46.753 Z"
                        ></path>
                      </svg>
                    </span>
                    <span> </span>
                    <h1
                      style="width: max-content"
                      class="font-weight-bold white--text"
                    >
                      <span v-if="false"> الصفحة الرئيسية </span>
                      <span class="special_font"> Main Page </span>
                    </h1>
                  </span>
                </div>
              </div>
              <!-- START::__SEARCH__ -->
              <v-row dir="column" justify="center">
                <v-col cols="12" md="8">
                  <v-row
                    justify-lg="center"
                    justify="center"
                    align="center"
                    class="mt-12"
                  >
                    <v-col md="" class="d-flex justify-center" cols="10">
                      <div
                        class="search"
                        :class="{ search_input_style: isSearchInputFocused }"
                      >
                        <v-text-field
                          dark
                          @keydown.enter="
                            searchResult();
                            fetchSearch(search);
                          "
                          :placeholder="
                            $vuetify.breakpoint.mdAndUp
                              ? 'Search Movie (press /)'
                              : 'Search Movie'
                          "
                          :hide-details="true"
                          @focus="isSearchInputFocused = true"
                          @blur="isSearchInputFocused = false"
                          ref="search_button"
                          @click:append="
                            searchResult();
                            fetchSearch(search);
                          "
                          color="#111722"
                          v-model="search"
                          solo
                          background-color="rgba(255, 255, 255, .15)"
                        >
                          <template v-slot:append>
                            <v-slide-x-transition>
                              <v-icon
                                v-if="search != ''"
                                @click="
                                  searchResult();
                                  fetchSearch(search);
                                "
                                >mdi-magnify</v-icon
                              >
                            </v-slide-x-transition>
                          </template></v-text-field
                        >
                      </div>
                    </v-col>
                  </v-row>
                </v-col>
              </v-row>
            </section>
          </v-main>
        </v-col>
      </v-row>
    </v-img>
    <!-- landing-end -->
    <v-container class="pt-12 mt-12"> </v-container>
    <v-divider style="border-color: #8080802e" class="mb-3"></v-divider>
    <div class="main_heading">
      <h1>
        <span class="special_font">Top Movies</span>
      </h1>
      <span class="special_design">
        <i></i>
        <i></i>
        <i></i>
      </span>
    </div>
    <MovieItem :toprated="toprated"  />
    <!--  -->
    <v-divider style="border-color: #8080802e" class="mb-3 mt-12"></v-divider>
    <v-container>
      <div class="main_heading">
        <h1>
          <span class="special_font">Upcoming Movies</span>
        </h1>
        <span class="special_design">
          <i></i>
          <i></i>
          <i></i>
        </span>
      </div>
      <div class="upcoming">
        <template>
          <carousel-3d
            :listData="upcoming"
            :height="450"
            :key="upcoming.length"
            :controls-visible="!$vuetify.breakpoint.xsOnly?true:false"
            :clickable="true"
          >
            <slide
              :index="i"
              :key="i"
              v-for="(item, i) in this.upcoming"
              class="transparent"
            >
              <figure>
                <v-hover v-slot="{ hover }">
                  <v-img
                    :src="`https://image.tmdb.org/t/p/w500${item.poster_path}`"
                    class="d-flex align-end justify-center"
                    height="450"
                    contain
                  >
                    <template #placeholder>
                      <v-card class="fill-height" color="#111722">
                        <v-skeleton-loader
                          type="image, image, image"
                          v-bind="attrs"
                        />
                      </v-card>
                    </template>
                    <v-slide-y-reverse-transition>
                      <v-card v-if="hover" class="background transparent pb-12">
                        <v-card-text
                          class="d-flex align-center justify-center"
                          style="gap: 5px"
                        >
                          <v-chip
                            small
                            :color="
                              i % 2 == 0
                                ? 'primary'
                                : i % 3 == 0
                                ? 'success'
                                : i % 4 == 0
                                ? 'indigo'
                                : 'error'
                            "
                          >
                            <span>{{ item.original_title }}</span>
                          </v-chip>
                        </v-card-text>
                      </v-card>
                    </v-slide-y-reverse-transition>
                  </v-img>
                </v-hover>
                <figcaption>image</figcaption>
              </figure>
            </slide>
          </carousel-3d>
        </template>
      </div>
    </v-container>
  </v-app>
</template>

<script>
import { Carousel3d, Slide } from "vue-carousel-3d";
import { mapActions, mapState } from "vuex";
import MovieItem from "@/components/Movie/MovieItemC";
import axios from "axios";
export default {
  data: () => ({
    upcoming: [],
    toprated: [],
    contentLoaded: false,
    latest: [],
    imageTransition: true,
    isSearchInputFocused: false,
    search: "",
    attrs: {
      class: "mb-6",
      boilerplate: true,
      elevation: 2,
    },
    page: 1,
    firstLoad: true,
    apiKey: "194d8a67379374e13e12c99420c19098",
    items: [
      {
        icon: "mdi-movie-roll",
        title: "Movies",
        route: "/movies",
      },
      {
        icon: "mdi-film",
        title: "Serials",
      },
      {
        icon: "mdi-television",
        title: "Tv",
      },
      {
        icon: "mdi-controller-classic-outline",
        title: "Games",
      },
      {
        icon: "mdi-cog",
        title: "Programs",
      },
      {
        icon: "mdi-camera",
        title: "Others",
      },
    ],
  }),
  components: {
    Carousel3d,
    Slide,
    MovieItem,
  },
  computed: {
    ...mapState({
      S_dialog: (store) => store.movie.S_dialog,
    }),
  },
  methods: {
    ...mapActions([
      "A_searchResult",
      "A_changeSkeletonLoading",
      "A_enableDialog",
    ]),

    focusSearchInputWithKeyboardShortcut() {
      this.$nextTick(() => {
        window.addEventListener("keydown", (e) => {
          if (e.key != "/") return;
          if (!this.$refs.search_button) {
            return;
          } else {
            this.$refs.search_button.focus();
            e.preventDefault();
          }
        });
      });
    },
    async getUpComingMovies() {
      await axios
        .get(
          `https://api.themoviedb.org/3/movie/upcoming?api_key=${this.apiKey}&language=en-US&page=1`
        )
        .then((resp) => {
          this.upcoming = resp.data.results;
        });
    },
    async fetchSearch(searcharg) {
      if (this.search != "") {
        await axios
          .get(
            `https://api.themoviedb.org/3/search/movie?query=${searcharg}&api_key=${this.apiKey}`
          )
          .then((resp) => {
            // console.log(resp);
            this.searchList = resp.data.results;
            this.A_searchResult(resp.data.results);
          });
      }
    },
    searchResult() {
      if (this.search != "") {
        if (this.$route.name === "moviedetail") {
          this.A_changeSkeletonLoading(true);
          setTimeout(() => {
            this.A_changeSkeletonLoading(false);
          }, 2000);
        } else {
          this.A_changeSkeletonLoading(true);
          this.A_enableDialog(true);
          setTimeout(() => {
            this.A_enableDialog(false);
            this.A_changeSkeletonLoading(false);
          }, 2000);
          this.$router
            .push({
              name: "moviedetail",
              params: { id: this.search },
              query: { q: this.search },
            })
            .then(() => {
              this.$vuetify.goTo(0, {
                duration: 750,
              });
            });
        }
        localStorage.setItem("searchKey", this.search);
      }
      // this.search = "";
    },
    async getTopRatedMovies() {
      await axios
        .get(
          `https://api.themoviedb.org/3/movie/top_rated?api_key=${this.apiKey}&language=en-US&page=1`
        )
        .then((resp) => {
          // console.log(resp);
          this.toprated = resp.data.results;
        });
    },
    async getLatestMovies() {
      await axios
        .get(
          `https://api.themoviedb.org/3/movie/latest?api_key=${this.apiKey}&language=en-US&page=1`
        )
        .then((resp) => {
          // console.log(resp);
          // console.log(
          //   `https://api.themoviedb.org/3/movie/latest?api_key=${this.apiKey}&language=en-US&page=1`
          // );
          this.latest = resp.data;
        });
    },
    imageAnimation() {
      this.imageTransition = true;
      setTimeout(() => {
        this.imageTransition = false;
        // this.$refs.search_button.focus();
      }, 1500);
    },
  },
  mounted() {
    this.getUpComingMovies();
    this.getTopRatedMovies();
    this.imageAnimation();
    this.focusSearchInputWithKeyboardShortcut();
  },
  created() {
    const readyHandler = () => {
      if (document.readyState == "complete") {
        setTimeout(() => {
          this.firstLoad = false;
        }, 1500);
        document.removeEventListener("readystatechange", readyHandler);
      }
    };
    document.addEventListener("readystatechange", readyHandler);
    readyHandler();
  },
};
</script>

<style lang="scss" scoped>
.search_settings {
  box-shadow: none !important;
  border-radius: 10px !important;
}
.search {
  width: 100%;
  max-width: 85%;
  transition: all 0.3s;
  transition-timing-function: cubic-bezier(0.68, -0.55, 0.27, 1.55);
}
.search_input_style {
  max-width: 100%;
}
@import "~vuetify/src/styles/settings/_variables";
.the_back {
  // background-image: url("../../assets/movie/landing-03.jpg");
  background-position: center;
  background-size: cover;
  // background-color: #111722;
  position: relative;
  &::before {
    position: absolute;
    content: "";
    width: 100%;
    height: 100%;
    top: 0;
    left: 0;
    background: rgba($color: #111722, $alpha: 0.6);
  }
}
.home_bg {
  // @extend .the_back;
  // min-height: 100vh;
}
// .upcoming {
// }
.newback {
  background: linear-gradient(to top, #111722, #202a3d);
}
#Home {
  .home_logo {
    overflow: hidden;
    cursor: pointer;
    width: 250px;
    height: 250px;
    position: relative;
    &::after {
      border: 2px solid white;
      transition: 0.3s 0.1s;
      position: absolute;
      content: "";
      width: 100%;
      height: 100%;
      border-radius: 50%;
    }
    &::before {
      border: 2px solid white;
      position: absolute;
      content: "";
      transition: 0.3s;
      width: 50%;
      height: 50%;
      z-index: 1;
      border-radius: 50%;
    }
    border-radius: 50%;
    &:hover::before,
    &:focus::before {
      border-color: #26baee;
      width: 100%;
      height: 100%;
      transition: 0.3s;
    }
    &:hover .logo_content {
      border: 5px solid #26baee;
    }
    &:hover .logo_content .logo {
      top: -100%;
      transition: all 500ms;
      opacity: 0;
    }
    .logo_content {
      background-image: url("../../assets/akoamclone/site-new.webp");
      position: relative;
      overflow: hidden;
      width: 200px;
      z-index: 2;
      height: 200px;
      border: 5px solid white;
      border-radius: 50%;
      // background-color: #161619;
      background-color: #111722;
      overflow: hidden;
      background-position: center -40%;
      transition: background-position 5s;
      // transform: translateY(0px);
      background-repeat: no-repeat;
      background-size: 120%;
      .logo {
        position: absolute;
        top: 28px;
        right: 50%;
        transition: all 500ms;
        z-index: 2;
        transform: translate(50%);
      }
    }
    &:hover .logo_content {
      // transition: all 5s;
      border-color: #0d82ab;
      // animation: imageScroll 3s forwards;
      background-position: center 100%;
    }
  }
  .image_transtion {
    &::after {
      border: 0px solid #26baee;
      transition: 0.3s;
      width: 0%;
      height: 0%;
    }
    &::before {
      border-color: #26baee;
      width: 100%;
      height: 100%;
      transition: 0.3s;
    }
    & .logo_content {
      border: 5px solid #26baee;
    }
    & .logo_content .logo {
      top: -100%;
      transition: all 500ms;
      opacity: 0;
    }
    & .logo_content {
      border-color: #0d82ab;
      // background-position: center 100%;
      animation: imageTransition 5s forwards;
    }
  }
  @keyframes imageTransition {
    0% {
      background-position: center 100%;
    }
    100% {
      background-position: center -40%;
    }
  }
  .parent {
    text-align: center;
    display: flex;
    flex-wrap: wrap;
    align-content: center;
    justify-content: center;
    .transtion {
      transition: all 0.4s;
    }
    .child {
    }
  }
}
@keyframes imageScroll {
  0% {
    transform: translateY(0px);
  }
  100% {
    transform: translateY(-77%);
  }
}
* {
  font-family: akoam, Arial, Helvetica, sans-serif, sans-serif,
    "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol", "Noto Color Emoji";
}
.glasscolor {
  background: inherit;
  &::before {
    box-shadow: inset 0 0 2000px rgba(255, 255, 255, 0.5);
    filter: blur(10px);
  }
}
.visible_card {
  visibility: hidden !important;
}

.main_heading {
  margin-bottom: 60px;
  text-align: center;
  div {
    margin-bottom: 7px;
  }
  h1 {
    font-size: 40px;
    color: #cb834a;
    font-weight: 900;
    letter-spacing: 2px;
    margin-bottom: 10px;
  }
  span.special_design {
    position: relative;
    width: 200px;
    margin: 0px auto;
    display: flex;
    align-items: center;
    justify-content: center;
    &::before {
      position: absolute;
      content: "";
      width: 50%;
      left: 0;
      height: 3px;
      top: 50%;
      z-index: 0;
      transform: translateY(-50%);
      background: linear-gradient(to right, transparent, #cb834a);
    }
    &::after {
      position: absolute;
      content: "";
      right: 0;
      width: 50%;
      height: 3px;
      top: 50%;
      z-index: 0;
      transform: translateY(-50%);
      background: linear-gradient(to left, transparent, #cb834a);
    }
    i {
      width: 7px;
      display: inline-block;
      height: 7px;
      background: #cb834a;
      transform: rotate(45deg);
    }
  }
}
@import url("https://fonts.googleapis.com/css2?family=Josefin+Sans:ital,wght@0,300;0,400;0,500;0,600;0,700;1,400&family=Righteous&display=swap");
.special_font {
  // font-family: "Josefin Sans", sans-serif !important;
  font-family: "Righteous", cursive;
}
</style>
